/**
 * FlatButton.js
 * Minimal raised button using Paper
 *
 * @class FlatButton
 * @author  Randy Lebeau
 * @contributor Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import PropsJoin from '../../../mixins/js/PropsJoin';
import EnhancedButton from '../enhanced-button/EnhancedButton';
import Paper from '../../paper/Paper';

export default React.createClass({

	displayName: "RaisedButton",

	mixins: [ PropsJoin ],

	propTypes: {
		label: function(props, propName, componentName) {
			if (!props.children && !props.label) {
				return new Error('Warning: Required prop `label` or `children` was not specified in `' + componentName + '`.')
			}
		},
		onMouseDown: React.PropTypes.func,
		onMouseUp: React.PropTypes.func,
		onMouseOut: React.PropTypes.func,
		onTouchEnd: React.PropTypes.func,
		onTouchStart: React.PropTypes.func,
		status: React.PropTypes.string,
		primary: React.PropTypes.bool,
		secondary: React.PropTypes.bool,

	},

	getInitialState() {
		let zDepth = this.props.disabled ? 0 : 1;
		return {
			zDepth: zDepth,
			initialZDepth: zDepth
		};
	},

	getDefaultProps() {
		return {
			status: "primary"
		}
	},

	componentWillReceiveProps(nextProps) {
		let zDepth = nextProps.disabled ? 0 : 1;
		this.setState({
			zDepth: zDepth,
			initialZDepth: zDepth
		});
	},

	render() {
		let onClickAction;

		let {
			label,
			primary,
			secondary,
			href,
			to,
			params,
			query,
			active,
			onClick,
			target } = this.props;

		let classes = ClassNames('lui-raised-button', `lui-is-${this.props.status}`, this.props.className);

		let enhancedButtonClasses = ClassNames ('lui-raised-button-container' , this.props.className);

		let children;

		if (label) {
			children = <span className="lui-raised-button-label">{label}</span>
		} else {
			children = this.props.children;
		}

		return (
			<Paper className={classes} depth={this.state.zDepth} rounded={true}>
				<EnhancedButton {...this.props}
					className={enhancedButtonClasses}
					onMouseUp={this._handleMouseUp}
					onMouseDown={this._handleMouseDown}
					onMouseOut={this._handleMouseOut}
					onTouchStart={this._handleTouchStart}
					onTouchEnd={this._handleTouchEnd} >

					{children}
				</EnhancedButton>
			</Paper>
		);
	},

	_handleMouseDown(e) {
		//only listen to left clicks
		if (e.button === 0) {
			this.setState({
				zDepth: this.state.initialZDepth + 1
			});
		}
		if (this.props.onMouseDown) this.props.onMouseDown(e);
	},

	_handleMouseUp(e) {
		this.setState({
			zDepth: this.state.initialZDepth
		});
		if (this.props.onMouseUp) this.props.onMouseUp(e);
	},

	_handleMouseOut(e) {
		this.setState({
			zDepth: this.state.initialZDepth
		});
		if (this.props.onMouseOut) this.props.onMouseOut(e);
	},

	_handleTouchStart(e) {
		this.setState({
			zDepth: this.state.initialZDepth + 1
		});
		if (this.props.onTouchStart) this.props.onTouchStart(e);
	},

	_handleTouchEnd(e) {
		this.setState({
			zDepth: this.state.initialZDepth
		});
		if (this.props.onTouchEnd) this.props.onTouchEnd(e);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/buttons/raised-button/RaisedButton.js
 **/